import {
  Description as DescriptionIcon,
  Info as InfoIcon,
} from '@mui/icons-material';
import {
  Alert,
  AlertTitle,
  Box,
  Chip,
  Paper,
  Stack,
  Typography,
} from '@mui/material';
import { formatMoney } from 'lib/functions/utils';
import { Document } from 'lib/types/models';
import React from 'react';

export default function PaymentDocument({ document }: { document?: Document }) {
  const doc = document;

  return (
    <Paper sx={{ p: 1.5, boxShadow: 'none', border: '1px solid #e0e0e0' }}>
      <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 1.5 }}>
        <Box
          sx={{
            backgroundColor: 'primary.main',
            borderRadius: '50%',
            p: 0.5,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: 'white',
          }}
        >
          <DescriptionIcon sx={{ fontSize: '1rem' }} />
        </Box>
        <Box sx={{ flex: 1 }}>
          <Typography
            variant="h6"
            sx={{
              fontWeight: 700,
              color: 'text.primary',
              fontSize: '1rem',
              lineHeight: 1.1,
            }}
          >
            Documento de Pago
          </Typography>
          <Stack direction="row" spacing={0.5}>
            <Chip
              label={'Costo de emisión'}
              size="small"
              color="primary"
              variant="outlined"
              sx={{ height: '18px', fontSize: '0.65rem' }}
            />
            <Chip
              label={doc?.paidAt ? 'Pagado' : 'Pendiente'}
              size="small"
              color={doc?.paidAt ? 'success' : 'warning'}
              sx={{ height: '18px', fontSize: '0.65rem' }}
            />
          </Stack>
        </Box>
        <Box sx={{ textAlign: 'right' }}>
          <Stack
            direction="row"
            alignItems="start"
            justifyContent="flex-end"
            spacing={0.75}
          >
            <Typography variant="h4" color="primary">
              {formatMoney(doc?.amount ?? 0)}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              CLP
            </Typography>
          </Stack>
        </Box>
      </Stack>

      <Alert
        severity="info"
        icon={<InfoIcon sx={{ fontSize: '0.9rem' }} />}
        sx={{
          borderRadius: 0.5,
          backgroundColor: 'rgba(25, 118, 210, 0.08)',
          border: '1px solid rgba(25, 118, 210, 0.2)',
          py: 0.75,
          mt: 2,
          '& .MuiAlert-message': { py: 0.25 },
        }}
      >
        <AlertTitle sx={{ fontWeight: 600, fontSize: '0.75rem' }}>
          Información Importante
        </AlertTitle>
        <Typography
          variant="body2"
          sx={{ fontSize: '0.75rem', lineHeight: 1.2 }}
        >
          {doc?.paidAt
            ? 'El pago ha sido registrado por el cliente. El certificado de garantía será emitido automáticamente.'
            : 'El certificado de garantía no será emitido hasta que se realice y verifique el pago correspondiente.'}
        </Typography>
      </Alert>
    </Paper>
  );
}
